module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "rules": _vm.rule,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Old Password",
      "prop": "old"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.old),
      callback: function($$v) {
        _vm.$set(_vm.account, "old", $$v)
      },
      expression: "account.old"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "new"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.new),
      callback: function($$v) {
        _vm.$set(_vm.account, "new", $$v)
      },
      expression: "account.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "confirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.account.confirm),
      callback: function($$v) {
        _vm.$set(_vm.account, "confirm", $$v)
      },
      expression: "account.confirm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7502fa36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/public/password.vue
// module id = 792
// module chunks = 1